import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pwd310Api, QueryParams, VendorSummary, ReportSummary } from '../../../services/pwd310Api';

export interface PWD310QueryState {
  loading: boolean;
  data: VendorSummary[];
  summary: ReportSummary | null;
  queried: boolean;
  noData: boolean;
}

export interface PWD310QueryActions {
  runQuery: (params: QueryParams) => Promise<void>;
  reset: () => void;
}

const emptySummary: ReportSummary = {
  total_receipt: 0,
  total_return: 0,
  total_payment: 0,
  total_balance: 0,
  vendor_count: 0,
};

export function usePWD310Query(): PWD310QueryState & PWD310QueryActions {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<VendorSummary[]>([]);
  const [summary, setSummary] = useState<ReportSummary | null>(null);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    if (!params.dateFrom || !params.dateTo) {
      message.warning('請輸入起迄日期');
      return;
    }

    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pwd310Api.query(params);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setSummary(resp.summary || emptySummary);
        setNoData(false);
      } else {
        setData([]);
        setSummary(null);
        setNoData(true);
        message.info(resp.message || '查無符合條件的對帳資料!');
      }
      setQueried(true);
    } catch (err) {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setSummary(null);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, summary, queried, noData, runQuery, reset };
}
